import styled from 'styled-components';
export var TextFieldWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledTextField__TextFieldWrapper",
  componentId: "qmj11d-0"
})(["width:100%;"]);
export var StyledTextField = /*#__PURE__*/styled.input.withConfig({
  displayName: "StyledTextField",
  componentId: "qmj11d-1"
})(["width:100%;box-sizing:border-box;border:1px solid ", ";background-color:", ";appearance:none;outline:none;font-family:", ";font-size:", ";font-weight:", ";padding:0.688rem ", ";margin:0;", " color:", ";transition:border 100ms cubic-bezier(0.46,0.03,0.52,0.96);&::placeholder{color:", ";}&:focus{border:1px solid ", ";box-shadow:none;}"], function (_ref) {
  var disabled = _ref.disabled,
    error = _ref.error,
    success = _ref.success,
    _ref$outlined = _ref.outlined,
    outlined = _ref$outlined === void 0 ? true : _ref$outlined,
    theme = _ref.theme;
  if (!outlined) {
    return theme.colors.background.white;
  }
  if (disabled) {
    return 'rgba(0,0,0,0)';
  }
  if (error) {
    return theme.colors.border.alert;
  }
  if (success) {
    return theme.colors.border.proceed;
  }
  return theme.colors.border.gray;
}, function (_ref2) {
  var disabled = _ref2.disabled,
    outlined = _ref2.outlined,
    theme = _ref2.theme;
  return disabled && outlined ? theme.colors.background.lightGray : theme.colors.background.white;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontFamily.primary;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fonts.fontSize.ft16;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fonts.fontWeight.normal;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.spacing.sp16;
}, function (_ref7) {
  var success = _ref7.success,
    theme = _ref7.theme;
  return success && "padding-right: ".concat(theme.spacing.sp32, ";");
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.text.primary;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.text.midGray;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.border.primary;
});
export var ErrorMessage = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledTextField__ErrorMessage",
  componentId: "qmj11d-2"
})(["color:", ";font-family:", ";font-size:", ";margin-top:", ";display:block;"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.text.alert;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.fonts.fontFamily.primary;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.fonts.fontSize.ft14;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.spacing.sp4;
});
export var SuccessMessage = /*#__PURE__*/styled(ErrorMessage).withConfig({
  displayName: "StyledTextField__SuccessMessage",
  componentId: "qmj11d-3"
})(["color:", ";"], function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.text.success;
});
export var IconWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledTextField__IconWrapper",
  componentId: "qmj11d-4"
})(["position:absolute;top:15px;right:10px;&& > svg{display:block;}"]);
export var InputRow = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledTextField__InputRow",
  componentId: "qmj11d-5"
})(["display:flex;align-items:center;"]);
export var InputWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledTextField__InputWrapper",
  componentId: "qmj11d-6"
})(["flex:1;position:relative;"]);
export var ActionsWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledTextField__ActionsWrapper",
  componentId: "qmj11d-7"
})(["margin-left:", ";"], function (_ref16) {
  var theme = _ref16.theme;
  return theme.spacing.sp16;
});